module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_vm._t("header")], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectPreviousRow($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectNextRow($event)
      }]
    }
  }, [_vm._t("default", null, {
    activeRow: _vm.activeRow
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ce499542"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectableGrid.vue
// module id = 1708
// module chunks = 1